import { render, staticRenderFns } from "./CarDetailsPrint.vue?vue&type=template&id=656ef20d&scoped=true&"
import script from "./CarDetailsPrint.vue?vue&type=script&lang=js&"
export * from "./CarDetailsPrint.vue?vue&type=script&lang=js&"
import style0 from "./CarDetailsPrint.vue?vue&type=style&index=0&id=656ef20d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656ef20d",
  null
  
)

export default component.exports